import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=29f60d29&scoped=true"
import script from "./judge.vue?vue&type=script&lang=js"
export * from "./judge.vue?vue&type=script&lang=js"
import style0 from "./judge.vue?vue&type=style&index=0&id=29f60d29&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f60d29",
  null
  
)

export default component.exports